import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
  return (
    <section id="contact">
      <div className="container">
        <h1>Get in touch.</h1>
        <p>
          I Would Be Happy To Further Discuss My Experiences With You, Simply Shoot Me An Email Or Message Me On LinkedIn!
        </p>
        <p>
          <h2 style={{ fontSize: '30px' }}>meanjaliofficials@gmail.com</h2>
        </p>
        <div className="contact-container">
          <div className="contact-item">
            <a href="mailto:meanjaliofficials@gmail.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faEnvelope} className="icon" />
            </a>
          </div>
          <div className="contact-item">
            <a href="https://www.linkedin.com/in/itsanjalich/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} className="icon" />
            </a>
          </div>
          <div className="contact-item">
            <a href="https://github.com/itsanjalich/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGithub} className="icon" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
